// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".transition-fade-enter-active[data-v-3b965259],.transition-fade-leave-active[data-v-3b965259]{-webkit-transition:opacity .15s;transition:opacity .15s}.transition-fade-enter[data-v-3b965259],.transition-fade-leave-to[data-v-3b965259]{opacity:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
